module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Check-76b9f057bc583c8f26f74e9512728933.svg";